/** Messages exchanged between src/sw.ts and the page (both bundles import this file). */

/** Background Sync tag registered when a sale is queued offline (task.md §4.14). */
export const SALES_SYNC_TAG = 'agrogruda-sales';

/** Worker → page: connectivity is back (sync event) — submit the queued sales with the page's session. */
export const FLUSH_SALES_MESSAGE = 'FLUSH_SALES';
/** Page → worker: activate the waiting worker now (update prompt). */
export const SKIP_WAITING_MESSAGE = 'SKIP_WAITING';
/**
 * Worker → page: a network fetch behind a NetworkFirst route failed / succeeded again. navigator.onLine stays
 * true on some platforms (and inside a service-worker-served navigation), so the worker's view of the network
 * drives the offline banner too.
 */
export const NETWORK_FAILED_MESSAGE = 'NETWORK_FAILED';
export const NETWORK_OK_MESSAGE = 'NETWORK_OK';

const MESSAGE_TYPES = [
  FLUSH_SALES_MESSAGE,
  SKIP_WAITING_MESSAGE,
  NETWORK_FAILED_MESSAGE,
  NETWORK_OK_MESSAGE,
] as const;

export interface SwMessage {
  type: (typeof MESSAGE_TYPES)[number];
}

export function isSwMessage(data: unknown): data is SwMessage {
  if (typeof data !== 'object' || data === null || !('type' in data)) return false;
  const type: unknown = data.type;
  return (MESSAGE_TYPES as readonly unknown[]).includes(type);
}
